import React, { useState, useEffect } from 'react'
import { message } from 'antd'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import request from 'meinian-package/src/utils/request'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import styles from './index.module.less'

const LEVELS = [
  { label: '1级', value: 1 },
  { label: '2级', value: 2 },
  { label: '3级', value: 3 },
  { label: '4级', value: 4 },
  { label: '5级', value: 5 },
  { label: '6级', value: 6 },
  { label: '7级', value: 7 },
  { label: '8级', value: 8 },
  { label: '9级', value: 9 },
]

export default () => {
  const [isSelect, setIsSelect] = useState(false)
  const [auditLevel, setAuditLevel] = useState()

  useEffect(() => {
    fetchAuditData()
  }, [])

  const onAuditChange = () => {
    request.get('/zhikuan/ins/inspiration/work/platform/update-team-need-mark-times', { params: { needMarkTimes: auditLevel } }).then(success => {
      if (success) {
        message.success('修改成功')
      }
    })
  }

  const fetchAuditData = () => {
    request.get('/zhikuan/ins/inspiration/work/platform/get-team-need-mark-times').then(res => {
      setAuditLevel(res)
    })
  }

  return <div className={styles.layerSetting}>
    <div className="layerSettingTitle">
      团队默认审核层级
    </div>
    <div className="layerSettingTitleLine" />
    <div className="layerSettingContent">
      <div className="layerSettingContentHeader">
        <div>团队默认审核层级</div>
        <div>
          {
                isSelect ? <span
                  style={{ color: 'var(--m-main)', cursor: 'pointer', }}
                  onClick={() => {
                    onAuditChange()
                    setIsSelect(false)
                  }}
                >完成</span> : <span>
                  {auditLevel}级
                  {
                    teamHasAuth('meinian_mark_times') && <Icon
                      type="m-kuaisubianji"
                      className="layerSettingContentHeaderIcon"
                      onClick={() => setIsSelect(true)}
                    />
                  }
                </span>
            }
        </div>
      </div>
      <div className="layerSettingContentSelect">
        {LEVELS.map(item => <div
          key={item.value}
          onClick={() => {
            if (isSelect) {
              setAuditLevel(item.value)
            }
          }}
          className={classNames('layerSettingContentSelectItem', {
            isSelect,
            active: item.value === auditLevel
          })}
        >{item.label}</div>)}
      </div>
    </div>
  </div>
}
